import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportaltraining.b2clogin.com/tfp/mncportaltraining.onmicrosoft.com'
};

const BASE_WEB_URL = 'https://web-codemanagement.portaltraining.mynexuscare.com/';

const consentScopes = [
  'https://mncportaltraining.onmicrosoft.com/api/api.Write',
  'https://mncportaltraining.onmicrosoft.com/api/api.Read',
  'https://mncportaltraining.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  b2cPolicies: b2cPolicies,
  production: false,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: BASE_WEB_URL,
  apiUrl: 'https://api-homehealth.portaltrn.mynexuscare.com',
  platformApiUrl: 'https://api-platform.portaltrn.mynexuscare.com',
  registryUrl: 'https://api-platform.portaltrn.mynexuscare.com/api/app-registry',
  authConfig: {
    config: {
      auth: {
        clientId: 'c855ea59-5da0-4e61-93ad-6dce536c33ae',
        postLogoutRedirectUri: `${BASE_WEB_URL}login`,
        redirectUri: `${BASE_WEB_URL}login`,
        knownAuthorities: ['mncportaltraining.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
      },
    },
    angularConfig: {
      consentScopes: consentScopes,
      protectedResourceMap: [
        [
          'https://mnc-trn-api-code-management.azurewebsites.net',
          consentScopes
        ],
        [
          'https://mnc-trn-api-platform.azurewebsites.net/',
          consentScopes
        ]
      ]
    }
  }
};